export const faqItems = [
  {
    id: 1,
    question: 'Preciso agendar ou aceitam walk-in?',
    answer: 'Trabalhamos preferencialmente com agendamento para garantir o melhor atendimento, mas aceitamos clientes sem agendamento conforme disponibilidade. Recomendamos agendar pelo WhatsApp para garantir seu horário.',
  },
  {
    id: 2,
    question: 'Quanto tempo dura cada atendimento?',
    answer: 'O corte masculino leva aproximadamente 45 minutos. A barba completa, 30 minutos. O combo corte + barba leva cerca de 60 minutos. Para outros serviços, o tempo varia conforme a complexidade.',
  },
  {
    id: 3,
    question: 'Atendem crianças e adolescentes?',
    answer: 'Sim! Atendemos homens de todas as idades. Temos experiência com cortes infantis e juvenis, sempre com o mesmo padrão de excelência e cuidado que define a Tal Pai, Tal Filho.',
  },
  {
    id: 4,
    question: 'Quais produtos vocês utilizam?',
    answer: 'Trabalhamos exclusivamente com produtos premium de marcas reconhecidas internacionalmente. Utilizamos linhas profissionais que garantem o melhor resultado e cuidado para cabelo e barba.',
  },
  {
    id: 5,
    question: 'Fazem barba com navalha?',
    answer: 'Sim, a navalha é uma das nossas especialidades. Todos os nossos barbeiros são treinados nas técnicas tradicionais de barbear com navalha, garantindo o acabamento mais rente e preciso possível.',
  },
  {
    id: 6,
    question: 'Oferecem café, água ou whisky?',
    answer: 'Sim. Oferecemos café espresso, água, whisky 12 anos e cerveja artesanal como cortesia para todos os clientes durante o atendimento. É parte da experiência premium que proporcionamos.',
  },
  {
    id: 7,
    question: 'Têm estacionamento?',
    answer: 'Sim, dispomos de estacionamento exclusivo para clientes, com manobrista disponível em horário comercial. Seu carro fica seguro enquanto você desfruta dos nossos serviços.',
  },
];